import { Navigate, Outlet, useLocation } from "react-router-dom";
import TokenService from "services/TokenService";

const useAuth = () => {
  const location = useLocation();
  console.log(location.pathname);
  if (location.pathname.includes("complete-registration")) {
    TokenService.removeUser();
  } else {
    const user = localStorage.getItem("LoggedInUser");
    if (user) {
      return true;
    } else {
      return false;
    }
  }
};

const ProtectedRoutes = () => {
  const auth = useAuth();

  return auth ? <Outlet /> : <Navigate to="login" />;
};

export default ProtectedRoutes;
